// Inspiration: https://codepen.io/brian-baum/pen/mJZxJX

const smoothScroll = (id: string) => {
  const node = document.getElementById(id.replace('#', ''));
  if (!node) return;
  node.scrollIntoView({ behavior: 'smooth' });
};

export default smoothScroll;
